import React, { useContext } from 'react';

import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';

export function MinutaDeContratoStep() {
  const { statusCodigo, demandaData } = useContext(QuestionarioContextProvider);

  switch (statusCodigo) {
    case EStatusDemanda.AguardandoConfirmacaoQuestionarioMinuta:
      return (
        <>
          {demandaData &&
          demandaData.perguntasQuestionarioMinuta &&
          demandaData.perguntasQuestionarioMinuta.length > 0 ? (
            <h3 style={{ textAlign: 'center' }}>
              Aguardando confirmação do questionário
            </h3>
          ) : (
            <h3 style={{ textAlign: 'center' }}>
              Nenhuma pergunta do questionário necessita de confirmação
            </h3>
          )}
        </>
      );
    case EStatusDemanda.AguardandoGeracaoMinuta:
      return <h3 style={{ textAlign: 'center' }}>Por favor, aguarde a geração da minuta para a demanda</h3>;
    default:
      return (
        <h3 style={{ textAlign: 'center' }}>
          Aguardando o preenchimento do questionário pelo Administrador de Contrato
        </h3>
      );
  }
}
